import type { StorageLocationsSortBy } from 'src/apis/storage/types';

export const storageLocationsSortByValues = [
  'NAME',
  'LOCATION_BUSINESS_ID',
  'SSO_NAME',
] as const satisfies readonly StorageLocationsSortBy[];
